import { useEffect, useState } from 'react';
import { getProjectLang, getLangDatingFileUrl, L } from '@lang';
import { getTranslationsLang, hideSplashscreen, showSplashscreen } from './helpers';
import { ErrorPage } from './pages/ErrorPage';
import { type LangLoadState, envs, AppContextProvider } from './core';
import { PwaInstallController } from './pages/PwaInstallController';

const projectLang = getProjectLang({
  supportedLangs: ['ru', 'en', 'kz', 'be'],
  inputLang: getTranslationsLang(),
  defaultLang: 'ru',
});

export function App() {
  const [appLoadState, setAppLoadState] = useState<LangLoadState>('loading');

  const fetchLang = () => {
    setAppLoadState('loading');
    return L.init({
      lang: projectLang,
      defaultNsPrefix: envs.LANG_DEFAULT_PREFIX,
      sourceUrl: getLangDatingFileUrl(envs.API_HOST, projectLang),
    })
      .then(() => setAppLoadState('success'))
      .catch(() => setAppLoadState('error'));
  };

  useEffect(() => {
    fetchLang();
  }, []);

  const isAppLoadStateLoading = appLoadState === 'loading';

  useEffect(() => {
    if (isAppLoadStateLoading) {
      showSplashscreen();
    } else {
      hideSplashscreen();
    }
  }, [isAppLoadStateLoading]);

  if (appLoadState === 'loading') {
    // Показывается нативный сплеш-скрин с помощью эффекта выше
    return <></>;
  }

  if (appLoadState === 'error') {
    return <ErrorPage onRetry={fetchLang} />;
  }

  return (
    <AppContextProvider>
      <PwaInstallController />
    </AppContextProvider>
  );
}
